<template>
  <div>
    <LmFormSubtitles
      class="col-12 mt-3"
      text="Propiedades basadas en modo edición"
      />
    <LmCheckbox
      class="col-12"
      v-model="component.componentProps.isVisibleOnlyOnEditMode"
      :labelSingle="$t('visible_only_on_edit_mode')"
      @input="$emit('input', component)"
      />
    <LmCheckbox
      class="col-12"
      v-model="component.componentProps.isDisabledOnlyOnEditMode"
      :labelSingle="$t('disabled_only_on_edit_mode')"
      @input="$emit('input', component)"
      />
  </div>
</template>

<script>
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmFormSubtitles from '@/components/form/elements/LmFormSubtitles'

export default {
  props: {
    component: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LmCheckbox,
    LmFormSubtitles
  }
}
</script>
